import EmptyIcon from '../../assets/icons/empty.svg';

export const RegulatoryNoMappingsMessage = () => {
	return (
		<div className="flex h-[80vh] w-full flex-col items-center justify-center py-10">
			<img src={EmptyIcon} className="w-40" />
			<div className="flex flex-col items-center text-sm">
				<p>{`Nenhum mapeamento foi encontrado com esses parâmetros`}</p>
				<span className="font-semibold text-blue-800">
					{`Cadastre um ou altere os valores dos filtros para visualizar a matriz!`}
				</span>
			</div>
		</div>
	);
};
